import { render, staticRenderFns } from "./detailReservationLog.vue?vue&type=template&id=0cb40df4&"
import script from "./detailReservationLog.vue?vue&type=script&lang=js&"
export * from "./detailReservationLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports